import { useQuery } from '@tanstack/react-query';
import { auditApi, type AuditListParams } from '../api/audit';
import { ApiError } from '../api/client';
import type { AuditLogEntry, Page } from '../api/types';

export function useAudit(params: AuditListParams) {
  return useQuery<Page<AuditLogEntry>, ApiError>({
    queryKey: ['audit', 'list', params],
    queryFn: () => auditApi.list(params),
  });
}
